// src/components/DashboardLayout.tsx
// import React from "react";
// import Sidebar from "./Sidebar/Sidebar";
import { LayoutPropType } from "./type";
import { FC } from "react";
import Sidebar from "../../components/Vendo-view/sidebar";

const DashboardLayout: FC<LayoutPropType> = ({ children }) => {
  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content area */}
      <div className="flex-1 bg-[#1A2035] p-6">{children}</div>
    </div>
  );
};

export default DashboardLayout;
